import { Box, chakra, Flex, IconButton } from "@chakra-ui/react";

export const LeftContainer = chakra(Box, {
  baseStyle: {
    flex: "1",
    borderRight: "1px solid #ddd",
    position: "relative",
    display: "flex",
    gap: "2",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});

export const ImageContainer = chakra(Flex, {
  baseStyle: {
    justify: "center",
    align: "center",
    h: "85%",
    w: "95%",
    mt: "10%",
    borderRadius: "20px",
    overflow: "hidden",
  },
});

export const StyledButton = chakra(IconButton, {
  baseStyle: {
    h: "44px",
    w: "48px",
    borderRadius: "8px",
    gap: "10px",
    m: "1",
    p: "4",
    border: "1px solid",
    borderColor: "gray.300",
    bg: "white",
    color: "black",
  },
});
